import React from 'react';
import { Calendar, MapPin, Clock, ExternalLink } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { Badge } from './ui/badge';
import { Button } from './ui/button';
import { newsData } from '../data/mock';

export const News = () => {
  return (
    <section id="news" className="py-20 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4">
            {newsData.title}
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            {newsData.subtitle}
          </p>
        </div>

        {/* Events Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {newsData.articles.map((article) => (
            <Card
              key={article.id}
              className="group overflow-hidden border-2 border-gray-100 hover:border-cyan-300 transition-all duration-300 hover:shadow-2xl hover:-translate-y-2"
            >
              {/* Image */}
              <div className="relative h-48 overflow-hidden bg-gray-100">
                <img
                  src={article.image}
                  alt={article.title}
                  loading="lazy"
                  decoding="async"
                  className="w-full h-full object-cover object-center group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute top-4 left-4">
                  <Badge className="bg-cyan-500 text-white hover:bg-cyan-600">
                    {article.category}
                  </Badge>
                </div>
              </div>

              <CardContent className="p-6">
                {/* Date, Time and Location */}
                <div className="space-y-2 mb-4">
                  <div className="flex items-center gap-2 text-sm text-gray-600">
                    <Calendar className="w-4 h-4 text-cyan-600" />
                    <span className="font-medium">{article.date}</span>
                  </div>
                  <div className="flex items-center gap-2 text-sm text-gray-600">
                    <Clock className="w-4 h-4 text-cyan-600" />
                    <span>{article.time}</span>
                  </div>
                  <div className="flex items-start gap-2 text-sm text-gray-600">
                    <MapPin className="w-4 h-4 text-cyan-600 flex-shrink-0 mt-0.5" />
                    <span>{article.location}</span>
                  </div>
                </div>

                {/* Title */}
                <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-cyan-600 transition-colors">
                  {article.title}
                </h3>

                {/* Excerpt */}
                <p className="text-gray-600 mb-4 leading-relaxed">
                  {article.excerpt}
                </p>

                {/* Map Link */}
                <a
                  href={article.mapsLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-block w-full"
                >
                  <Button
                    variant="outline"
                    className="w-full text-cyan-600 hover:text-cyan-700 hover:bg-cyan-50 border-cyan-300 group/btn"
                  >
                    <MapPin className="w-4 h-4 mr-2" />
                    Vedi sulla mappa
                    <ExternalLink className="w-4 h-4 ml-2 group-hover/btn:translate-x-1 transition-transform" />
                  </Button>
                </a>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};
